const app = {
  state: {
    articleReadonly: false
  },
  mutations: {
    setArticleReadonly(state, value) {
      state.articleReadonly = value;
    }
  },
  actions: {
    setArticleReadonly({ commit }, value) {
      commit('setArticleReadonly', value);
    }
  },
  getters: {
    articleReadonly: state => state.articleReadonly
  }
};
export default app;
